<template>
  <NotificationTypeWrapper :notification="notification">
    <p class="my-0">
      A
      <a
        :href="actionLink"
        v-text="'draft text message'"
      />
      has been shared with your organization{{ sharingUnion }}
    </p>
  </NotificationTypeWrapper>
</template>

<script type="text/babel">
import NotificationTypeMixin from './NotificationTypeMixin'

export default {
  name: 'SMSHasBeenShared',
  mixins: [NotificationTypeMixin],
  computed: {
    sharingUnion() {
      return this.notification.attributes.data.shared_by_union_name
        ? ` from ${this.notification.attributes.data.shared_by_union_name}.`
        : '.'
    },
    actionLink() {
      return this.$urlGenerator.active() + 'communications/sms/' + this.notification.attributes.data.sms_uuid
    },
  },
}
</script>
